const REGEX_YYYYMMDD = /^(\d{4})(\d{2})(\d{2})$/;
const REGEX_YYYYMMDD_HYPHEN = /^(\d{4})-(\d{2})-(\d{2})$/;
const REGEX_YYYYMMDD_SLASH = /^(\d{4})\/(\d{2})\/(\d{2})$/;
const REGEX_YYYYMM = /^(\d{4})(\d{2})$/;
const REGEX_YYYYMM_HYPHEN = /^(\d{4})-(\d{2})$/;

function parseYmdWithRegex(value: string, regex: RegExp): Date | undefined {
    const match = value.match(regex);
    if (match) {
        const y = parseInt(match[1], 10);
        const m = parseInt(match[2], 10);
        const d = parseInt(match[3], 10);
        const result = new Date(Date.UTC(y, m - 1, d));
        if (result.getMonth() > m - 1 || result.getFullYear() > y) {
            result.setDate(0);
        }
        return result;
    } else {
        return undefined;
    }
}

function calcLastDayOfMonth(year: number, monthFromZero: number): number {
    return new Date(year, monthFromZero + 1, 0).getDate();
}

function parseYmWithRegex(value: string, regex: RegExp): Date | undefined {
    const match = value.match(regex);
    if (match) {
        const y = parseInt(match[1], 10);
        const m = parseInt(match[2], 10);
        return new Date(Date.UTC(y, m - 1, 1));
    } else {
        return undefined;
    }
}

export class FtDate {
    private readonly date: Date;

    static fromYmd(year: number, month: number, day: number): FtDate {
        return new FtDate(new Date(Date.UTC(year, month - 1, day)));
    }

    constructor(value: string | Date | number | undefined = undefined) {
        if (value === undefined || value === null || value === "") {
            const now = new Date();
            const y = now.getFullYear();
            const m = now.getMonth();
            const d = now.getDate();
            this.date = new Date(Date.UTC(y, m, d));
        } else if (typeof value === "string") {
            new Date()
            const parsed = parseYmdWithRegex(value, REGEX_YYYYMMDD)
                ?? parseYmdWithRegex(value, REGEX_YYYYMMDD_HYPHEN)
                ?? parseYmdWithRegex(value, REGEX_YYYYMMDD_SLASH)
                ?? parseYmWithRegex(value, REGEX_YYYYMM)
                ?? parseYmWithRegex(value, REGEX_YYYYMM_HYPHEN);

            if (parsed === undefined) {
                throw new Error('Invalid date format');
            } else {
                this.date = parsed;
            }
        } else if (typeof value === 'number') {
            if (value < 10000000000) {
                this.date = new Date(value * 1000);
            } else {
                this.date = new Date(value);
            }
        } else if (value instanceof Date) {
            this.date = new Date(value.getTime());
        } else {
            throw new Error('Invalid date value');
        }
    }

    ymd(separator: string = "-"): string {
        return this.date.toISOString().substring(0, 10).replace(/-/g, separator);
    }

    ym(separator: string = "-"): string {
        return this.date.toISOString().substring(0, 7).replace(/-/g, separator);
    }

    addMonth(increment: number): FtDate {
        let y = this.date.getFullYear();
        let m = this.date.getUTCMonth() + increment;
        if (m < 0) {
            y -= Math.ceil(-m / 12);
            m = (m % 12 + 12) % 12;
        } else if (m > 11) {
            y += Math.floor(m / 12);
            m = m % 12;
        }

        const newDate = new Date(Date.UTC(y, m, 1));
        newDate.setDate(Math.min(this.date.getUTCDate(), calcLastDayOfMonth(y, m)));
        return new FtDate(newDate);
    }

    addDay(increment: number): FtDate {
        return new FtDate(this.date.getTime() + increment * 24 * 60 * 60 * 1000);
    }

    setMonth(month: number): FtDate {
        const newDate = new Date(this.date.getTime());
        newDate.setUTCMonth(month - 1);
        return new FtDate(newDate);
    }

    setDate(date: number): FtDate {
        const newDate = new Date(this.date.getTime());
        newDate.setUTCDate(date);
        return new FtDate(newDate);
    }

    lastDayOfMonth(): FtDate {
        const newDate = new Date(
            Date.UTC(
                this.date.getFullYear(),
                this.date.getMonth() + 1,
                0 // 0 means the last day of the previous month
            )
        );
        return new FtDate(newDate);
    }

    toDate(): Date {
        return new Date(this.date.getTime());
    }

    time(): number {
        return this.date.getTime();
    }
}
